// The service worker (public build output sw.js, written by the build: see vite.config.ts): registers it in the built app only,
// and tells the interface when a newer copy of the app is installed and waiting ("New version ready · Reload").

let waiting: ServiceWorker | null = null;

/** The notice is for a returning visit: with no controller yet, the first install is simply the app. */
function announceIfWaiting(reg: ServiceWorkerRegistration, onUpdate: () => void): void {
  if (reg.waiting && navigator.serviceWorker.controller) {
    waiting = reg.waiting;
    onUpdate();
  }
}

export function registerServiceWorker(onUpdate: () => void): void {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return;
  const start = () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((reg) => {
      announceIfWaiting(reg, onUpdate);
      reg.addEventListener('updatefound', () => {
        const next = reg.installing;
        next?.addEventListener('statechange', () => { if (next.state === 'installed') announceIfWaiting(reg, onUpdate); });
      });
      // A new deploy is found when the dancer comes back to the app, and otherwise every hour.
      const look = () => { reg.update().catch(() => { /* offline: nothing to find */ }); };
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') look(); });
      window.setInterval(look, 60 * 60 * 1000);
    }).catch(() => { /* no service worker (private window, blocked): the app still works online */ });
  };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
}

/** Make the waiting copy the active one, then load the page again so it runs on it. */
export function reloadForUpdate(): void {
  if (!waiting) { location.reload(); return; }
  navigator.serviceWorker.addEventListener('controllerchange', () => location.reload(), { once: true });
  waiting.postMessage({ type: 'SKIP_WAITING' });
}
